import React, {useState} from 'react';
import {Document, Page} from "react-pdf/dist/esm/entry.webpack5";
import InfiniteScroll from 'react-infinite-scroll-component';
import rulesImage from '../../assets/images/actsRulesOrder/rules.svg';
import pdfImage from "../../assets/images/allNotices/pdf.png";
import DataLoader from "../../components/loader/dataLoader";
import "../../assets/css/pages/actsRulesOrders/style2.scss";
import useActRuleOrders from "../../hooks/public/useActRuleOrders";
import {Tooltip} from 'react-tooltip';

const Index2 = () => {
  const {
    data,
    getData,
    hasMore,
    pdfFile,
    isLoading,
    setLoading,
    handleDownload,
    handleShowPdf,
    setPdfFile
  } = useActRuleOrders();
  const [numPages, setNumPages] = useState(null);

  const onDocumentLoadSuccess = ({numPages}) => {
    setNumPages(numPages);
    setLoading(false);
  };

  return (
      <section className='acts-rules-orders'>
        <div className='custom-container'>
          <div className='content-section'>
            <h1 className='page-title'>ACTs, Rules & Orders</h1>
            <div className='content-body'>
              {
                  data && data.length > 0 &&
                  <InfiniteScroll
                      dataLength={data.length}
                      next={getData}
                      hasMore={hasMore}
                      loader={<DataLoader/>}
                  >
                    <div className='row mx-0 py-3'>
                      {data?.map(item => (
                          <div key={item.id} className="col-xl-3 col-lg-4 col-md-6">
                            <div className="custom-act-rules-order-card">
                              <div className="card-header">
                                <img src={rulesImage} alt="Rules Icon"/>
                              </div>
                              <div className="card-body">
                                <Tooltip id="titleEn"/>
                                <span
                                    data-tooltip-id="titleEn"
                                    className="title"
                                    data-tooltip-content={item.titleEn}
                                    data-tooltip-place="top">
                                  {item.titleEn}
                                </span>
                              </div>
                              <div className='custom-card-footer'>
                                {item.fileTag &&
                                    <div className='d-flex align-items-center justify-content-end'>
                                      <img
                                          role="button"
                                          data-toggle="modal"
                                          data-target="#staticBackdrop"
                                          onClick={() => handleShowPdf(item.fileTag)}
                                          className="mr-4 clickable pdf-icon"
                                          src={pdfImage}
                                          alt="pdf image"
                                      />
                                      <i
                                          className='fa fa-cloud-download download-icon clickable'
                                          onClick={() => handleDownload(item.fileTag)}
                                      />
                                    </div>
                                }
                              </div>
                            </div>
                          </div>
                      ))}
                    </div>
                  </InfiniteScroll>
              }

              <div className="modal fade"
                   id="staticBackdrop"
                   data-backdrop="static"
                   data-keyboard="false"
                   tabIndex="-1"
                   aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">ACTs, Rules & Orders PDF</h5>
                      <button
                          onClick={() => setPdfFile(null)}
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body p-2" style={{background: "lightgray"}}>
                      <center>
                        {isLoading && <DataLoader/>}
                        {
                            pdfFile &&
                            <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
                              {Array.from(
                                  new Array(numPages),
                                  (el, index) => (
                                      <Page
                                          key={`page_${index + 1}`}
                                          pageNumber={index + 1}
                                      />
                                  )
                              )}
                            </Document>
                        }
                      </center>
                    </div>
                    <div className="modal-footer">
                      <button
                          onClick={() => setPdfFile(null)}
                          type="button"
                          className="btn btn-secondary"
                          data-dismiss="modal">
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  );
};

export default Index2;
